import { render, staticRenderFns } from "./index.vue?vue&type=template&id=05048cda&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05048cda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/qhygcg-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05048cda')) {
      api.createRecord('05048cda', component.options)
    } else {
      api.reload('05048cda', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=05048cda&scoped=true", function () {
      api.rerender('05048cda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shop/index.vue"
export default component.exports